import {AfterViewInit, Component, EventEmitter, OnInit, Output, ViewChildren} from '@angular/core';

@Component({
  selector: 'app-create-folder',
  templateUrl: './create-folder.component.html',
  styleUrls: ['./create-folder.component.scss']
})
export class CreateFolderComponent implements OnInit, AfterViewInit {

  folderName: String = '';

  @Output() saveFolderEvent = new EventEmitter();
  @Output() cancelCreateFolderEvent = new EventEmitter();

  @ViewChildren('input') vc;

  constructor() { }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.vc.first.nativeElement.focus();
  }

  saveFolder() {
    if (!this.folderName) {
      return;
    }

    this.saveFolderEvent.next({ folderName: this.folderName });
  }

  cancelCreateFolder() {
    this.cancelCreateFolderEvent.next();
  }
}



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-list/create-folder/create-folder.component.ts